


import { createSlice } from "@reduxjs/toolkit";

export const dateForAppSlice = createSlice({
    name: 'dateForAppStore',
    initialState: {
        value: new Date().getTime()
    },
    reducers: {
        setDateForAppStore: (state, action) => {
            const dateAppMillis = new Date(action.payload).getTime()
            const dateNowMillis = new Date().getTime()

            if (dateAppMillis <= dateNowMillis) {
                state.value = action.payload
            } else {
                state.value = dateNowMillis
            }
        }
    }
})

export const { setDateForAppStore } = dateForAppSlice.actions

export default dateForAppSlice.reducer